import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
// import OpenInNewIcon from "@material-ui/icons/OpenInNew";

import useStyles from "./styles";
import HelpIcon from '@material-ui/icons/Help';

const ConfirmDialog = ({
  isOpen = false,
  type,
  subject,
  message,
  maxWidth,
  yesColor= 'primary',
  noColor='default',
  handlerRefuse,
  handlerAccept
}) => {
  const classes = useStyles();

  let icon = "";

  switch(type){
    case 'question': icon = <HelpIcon className={`${classes.icon} ${classes.colorGreen}`} />; break;
    case 'warning': icon = <HelpIcon className={`${classes.icon} ${classes.colorYellow}`} />; break;
    default: icon = '';
  }

  return (
    isOpen && 
    (<Dialog
      open={!!isOpen}
      className={classes.root}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={maxWidth}
    >
      <DialogTitle id="alert-dialog-title">{subject}</DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        {icon}
        {message && <DialogContentText id="alert-dialog-description" style={{color: 'black', textAlign: 'center'}} dangerouslySetInnerHTML={{ __html: message}} />}
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogActions }}>
      <Button
          variant="contained"
          size="large"
          color={noColor}
          data-cy="confirm-dialog-no"
          id="confirm-dialog-no"
          classes={{ root: classes.closeModal }}
          onClick={handlerRefuse}
        >
          Não
        </Button>
        <Button
          variant="contained"
          size="large"
          data-cy="confirm-dialog-yes"
          id="confirm-dialog-yes"
          color={yesColor}
          classes={{ root: classes.closeModal }}
          onClick={handlerAccept}
        >
          Sim
        </Button>
      </DialogActions>
    </Dialog>)
  );
};

export default ConfirmDialog;
